import { render } from "./GameView.vue?vue&type=template&id=2f1082c0&ts=true"
import script from "./GameView.vue?vue&type=script&lang=ts"
export * from "./GameView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alejandromillan/Documents/Projects/wrwlf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__